import $ from 'jquery'
$(document).ready(function () {

    var screen = window.outerWidth;
    if (screen < 798) {
        $('.page-sidebar ').addClass("close_icon");
    }
    $('body').on('click', '.action_icon', function () {
        $('td.p-frozen-column').removeClass('openedActionBox');
        $(this).closest('td.p-frozen-column').addClass('openedActionBox');
        $(".action-list-box").animate({
            width: "0px",
        }, 100);

        var spnid = $(this).attr("attribute-id");
        var length = ($(".sixelement" + spnid).find('a').length);

        var dWidth = parseInt((61 * length) + 32);

        $(".spn" + spnid).animate({
            width: "310px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        //fsm-list
        $(".style_class").animate({
            'width': dWidth + "px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        $(".sevenelement" + spnid).animate({
            width: "350px",

        }, 200);
    });
    $('body').on('click', '.close-action', function () {

        $(this).closest('td.p-frozen-column').removeClass('openedActionBox');
        $(".action-list-box").animate({
            width: "0px",

        }, 100);
    });


    $('body').on('click', '.action_icon_Demo', function () {
        $(this).parents("td").addClass("openAction");

        $(".action-list-box").animate({
            width: "0px",
        }, 100);
        var innerWidth = 0;
        var halfwidth = 0;
        var dWidth = 0;
        var spnid = $(this).attr("attribute-id");
        //var dWidth = parseInt((80 * length) + 32);
        var aTags = $(".sixelement" + spnid).find('a');
        aTags.each(function (index) {
            dWidth += $(this).outerWidth(); // Includes padding
            halfwidth = dWidth / 2 + 60;
            innerWidth = halfwidth;

        });

        $(".spn" + spnid).animate({
            'width': innerWidth + "px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': innerWidth + "px",

        }, 200);
        //fsm-list
        $(".style_class").animate({
            'width': innerWidth + "px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': innerWidth + "px",


        }, 200);
        $(".sevenelement" + spnid).animate({
            width: "350px",

        }, 200);
    });
    $('body').on('click', '.action_new_Demo', function () {
       
        $(this).parents("td").addClass("openAction");

        $(".action-list-box").animate({
            width: "0px",
        }, 100);

        var spnid = $(this).attr("attribute-id");
        var length = ($(".sixelement" + spnid).find('a').length);
        var dWidth = parseInt((340) + 1);
        // dWidth = parseInt((61 * length) + 32);

        $(".spn" + spnid).animate({
            width: "250px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        //fsm-list
        $(".style_class").animate({
            'width': dWidth + "px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        $(".sevenelement" + spnid).animate({
            width: "250px",

        }, 200);
    });


    $('body').on('click', '.close-action_Demo', function () {


        $(".action-list-box").animate({
            width: "0px",

        }, 100);
    });


    $(document).on("click", ".profile-avatar", function () {

        $(this).toggleClass("profile-menu");

    });

    //nav-page-sidebar
    //page-sidebar close_icon

    $(document).on("click", ".sub_moduleRoute", function () {
        var spnid = $(this).attr("attribute-id");
        $(".sidebar-link, .sub_moduleRoute ").removeClass("cust-active-module");
        $('.single_click').removeClass("active");
        $('.multiple_click ').removeClass("active");
        $('.addhighlited_' + spnid).addClass("active");

    });
    //sidebar-link my-click

    $(document).on("click", ".single_click ", function () {
        var spnid = $(this).attr("attribute-id");
        $(".sidebar-link, .sub_moduleRoute ").removeClass("cust-active-module");
        //collapsed
        $('.single_click').removeClass("active");
        $('.multiple_click ').removeClass("active");
        $('.menuElelment_' + spnid).addClass("active");
    })
})














